var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgWhiteQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18Zm0-1.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm-.278-1.598c-.712 0-1.222-.51-1.222-1.221 0-.721.51-1.231 1.222-1.231s1.213.51 1.213 1.23c0 .712-.501 1.222-1.213 1.222ZM5.85 6.476C5.938 4.753 7.132 3.6 9.072 3.6c1.827 0 3.137 1.138 3.137 2.7 0 1.104-.541 1.955-1.546 2.56-.84.496-1.075.84-1.075 1.533v.458l-.15.15H8.205l-.15-.15v-.647c-.007-.969.453-1.655 1.48-2.27.79-.484 1.063-.886 1.063-1.57 0-.804-.625-1.365-1.576-1.365-.978 0-1.596.56-1.668 1.496l-.15.138H6l-.15-.157Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteQuestionMark);
export default __webpack_public_path__ + "static/media/WhiteQuestionMark.77d25d29fac4aeabf3164c3f2d36f737.svg";
export { ForwardRef as ReactComponent };